import { StateList } from '../../models/StateList';
import { WBidStateCollection } from '../../models/WBidStateCollection';

export class SetStateFile {
  static readonly type = '[StateFile] Set';
  constructor(public payload: any) {} // Replace `any` with your actual type
}
export class AddStateFile {
  static readonly type = '[STATEFILE] add';
  constructor(public payload: WBidStateCollection) {}
}

export class RemoveStateFile {
  static readonly type = '[STATEFILE] remove';
  constructor() {
    /**/
  }
}

export class AddStateList {
  static readonly type = '[STATELIST] add';
  constructor(public payload: StateList) {}
}

export class RemoveStateList {
  static readonly type = '[STATELIST] remove';
  constructor() {
    /**/
  }
}
